module.exports = __webpack_public_path__ + "static/media/user-icon-1.60602e7d.png";